module.exports = __webpack_public_path__ + "static/media/valora.60030d6d.png";